import { useState } from "react";
import { Modal } from "../../components/ui/modal";
import { useToast } from "../../components/ui/toast";
import { useDeleteAgent } from "./queries";
import type { Agent } from "./types";

export function DeleteAgentModal({ agent, onClose }: { agent: Agent; onClose: () => void }) {
  const agentName = agent.agent_name || agent.name || "Untitled Agent";
  const [confirmName, setConfirmName] = useState("");
  const del = useDeleteAgent();
  const toast = useToast();

  const matches = confirmName === agentName;

  const onDelete = () => {
    del.mutate(agent.agent_id, {
      onSuccess: () => { toast.success("Agent deleted", agentName); onClose(); },
      onError: (e) => toast.danger("Delete failed", (e as Error).message),
    });
  };

  return (
    <Modal
      title="Delete Agent"
      subtitle={<>Type <strong className="text-ink">{agentName}</strong> to confirm deletion.</>}
      onClose={onClose}
      width="max-w-sm"
      footer={
        <>
          <button onClick={onClose} className="rounded-lg border border-line px-4 py-2 text-sm font-semibold text-ink hover:bg-soft">
            Cancel
          </button>
          <button
            onClick={onDelete}
            disabled={!matches || del.isPending}
            className="rounded-lg bg-danger px-4 py-2 text-sm font-semibold text-white hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-40"
          >
            {del.isPending ? "Deleting…" : "Delete Agent"}
          </button>
        </>
      }
    >
      <input
        type="text"
        value={confirmName}
        onChange={(e) => setConfirmName(e.target.value)}
        autoFocus
        className="w-full rounded-md border border-line bg-soft px-3 py-2 text-sm text-ink outline-none focus:border-brand"
        placeholder={agentName}
      />
    </Modal>
  );
}
